(() => {
  const membershipVariants = new Set(['58306376270198', '58306376335734']);

  const fixReturnTargets = () => {
    document
      .querySelectorAll('[data-kuf-payment-root] input[name="return_to"]')
      .forEach((input) => {
        input.value = '/checkout';
      });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fixReturnTargets, { once: true });
  } else {
    fixReturnTargets();
  }

  const previousFetch = window.fetch.bind(window);

  window.fetch = async (input, init) => {
    const url = typeof input === 'string' ? input : (input && input.url) || '';
    const body = init && init.body;
    const variantId = body instanceof FormData ? String(body.get('id') || '') : '';
    const isMembershipAdd = /\/cart\/add(?:\.js)?(?:\?|$)/.test(url) && membershipVariants.has(variantId);

    const response = await previousFetch(input, init);

    if (response.ok && isMembershipAdd) {
      window.location.assign('/checkout');
      return new Promise(() => {});
    }

    return response;
  };
})();
